import React, { useEffect, useCallback, useState } from 'react'
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from "react-toastify";
import { statusCodes, commonMessage } from "../../Constants/generalConfig";
import { otpValidation } from '../../Context/validation';
import { resendOTPApi, enterOtpApi } from '../../Context/api';
import ValidationMessage from '../../Component/validationMessage';

const VerifyOtp = () => {
  const [passwordShow, setPasswordShow] = useState(false);
  const [icon, setIcon] = useState(true);
  const navigate = useNavigate()
  const [timer, setTimer] = useState(60)
  const timeOutCallback = useCallback(() => setTimer((currTimer) => currTimer - 1), [])
  const email = JSON.parse(localStorage.getItem('email'))
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000)
  }, [timer, timeOutCallback])

  const resetTimer = () => {
    setTimer(60)
  }

  const resendOtp = () => {
    const data = { email: email }
    axios.post(resendOTPApi(), { ...data }).then((resp) => {
      if (resp.data.code === statusCodes.ok || resp.data.code === statusCodes.token) {
        toast.success(resp.data.message)
        resetTimer()
      }
      else if (resp.data.code === 410) {
        toast.success(resp.data.message)
      }
      else {
        toast.error(resp.data.message)
      }
    })
      .catch(() => {
        toast.error(commonMessage.networkError)
      })
  }

  const formik = useFormik({
    initialValues: {
      number: ''
    },
    validationSchema: otpValidation,
    onSubmit: values => {
      values = `${values.number}`
      const data = { otp: +values, email: email, timeZone: timeZone }
      axios.post(enterOtpApi(), { ...data }).then((resp) => {
        if (
          resp.data.code === statusCodes.ok
        ) {
          navigate('resetPin')
          toast.success(resp.data.message)
          localStorage.setItem('Token', JSON.stringify(resp.data.data.token))
        } else {
          toast.error(resp.data.message)
        }
      })
        .catch(() => {
          toast.error(commonMessage.networkError)
        })
    },
  });
  return (
    <>
      <ToastContainer />
      <section className="bg_img">
        <section>
          <div className="col-lg-12">
            <div className="container">
              <div className="col-lg-10 mx-auto">
                <div className="row" style={{ padding: '16% 0' }}>
                  <div
                    className="col-lg-6 bg_color border_reduas padd_img d-flex justify-content-center"
                  >
                    <img src={require('../../Assets/images/OTP.jpg')} className="border_reduas_2" alt="" />
                  </div>
                  <div className="col-lg-6 bg_white border_reduas_1 p-5">
                    <div className="ps-4 pt-5">
                      <h1 className="heading_color">Enter OTP</h1>
                      <p className="peragraf_color">
                        Enter OTP Sent on your Registered Email
                      </p>
                      <div className="pt-4">
                        <div className="input-group mb-4 mt-4 position-relative">
                          <span className="input-group-text" id="basic-addon1"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 15 15">
                            <path fill="#f47e3b" d="M3.5 6a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5M11 7h.5a.5.5 0 0 0 0-1H11z" />
                            <path fill="#f47e3b" fill-rule="evenodd" d="M0 1.5A1.5 1.5 0 0 1 1.5 0h12A1.5 1.5 0 0 1 15 1.5v12a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 0 13.5zm2 5a1.5 1.5 0 1 1 3 0v2a1.5 1.5 0 1 1-3 0zM7 6H6V5h3v1H8v4H7zm3-1h1.5a1.5 1.5 0 0 1 0 3H11v2h-1z" clip-rule="evenodd"
                            />
                          </svg>
                          </span>
                          <input
                            type={passwordShow ? "number" : "password"}
                            className="form-control form-control_Style"
                            placeholder="Please Enter OTP"
                            name='number'
                            aria-describedby="basic-addon1"
                            value={formik.values.number}
                            onChange={formik.handleChange}
                            maxLength={4}
                            onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}
                          />
                          <ValidationMessage name='number' formName={formik} />

                          <span className="position_forgot forgot_pin_new" style={{ display: `${timer > 0 ? 'none' : 'block'}` }}>Didn’t Received the OTP?
                            <span className="forgot_pin cursor" onClick={() => { resetTimer(); resendOtp() }} >Resend</span></span>
                          <span className="position_forgot forgot_pin_new" style={{ display: `${timer > 0 ? 'block' : 'none'}` }}>{timer} Second</span>
                          <span className="position_eye">
                            {icon ? (
                              <i className="fa fa-eye" style={{ color: '#F7A77A' }} onClick={() => { setPasswordShow(true); setIcon(false) }}></i>
                            ) : (
                              <i className="fa fa-eye-slash" aria-hidden="true" style={{ color: '#F7A77A' }} onClick={() => { setPasswordShow(false); setIcon(true) }}></i>
                            )}
                          </span>
                        </div>
                        <div className="pt-4">
                          <button className="my_btn" onClick={formik.handleSubmit}>Submit</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  )
}

export default VerifyOtp